import { render } from "./domains-list.vue?vue&type=template&id=1e05d980"
import script from "./domains-list.vue?vue&type=script&lang=js"
export * from "./domains-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__